
import Layout from '../../../layouts/main'
import { useState } from 'react';
import { toast } from 'react-toastify';
import config from '../../../../configuration/config.json'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import cbor from 'borc';
import { Buffer } from 'buffer';
import { useEffect } from 'react';


export default () => {
    const navigate = useNavigate();
    const [getdocuments, setdocuments] = useState([]);
    const [getSelectedDocId, setSelectedDocId] = useState('0');
    const [getActionMode, setActionMode] = useState('');


    const loadDataOnlyOnce = async () => {


        const response = await axios.request({
            method: 'GET',
            url: config.operatorportal.apibaseurl +'document/configurations/schemas',
            headers: { "content-type": "application/cbor", Authorization: `Bearer ${sessionStorage.getItem('access_token')}` },
            responseType: 'arraybuffer',
            responseEncoding: 'binary',
        });

        if (response.status == 200) {

            let documentSchemas = response.data;
            let documentSchemasDecoded = cbor.decode(new Buffer(response.data));
            setdocuments(documentSchemasDecoded);
            
        } else {
            setdocuments([]);
        }

    }

    useEffect(() => {
        loadDataOnlyOnce();
    }, [])

    return (
        <Layout>

            <div class="container-fluid mt-5">
                <div class='row'>
                    <h class='header1'>Label Local Language</h>
                </div>
                <div class="row">
                    <div class="col-md-6  mt-3">
                        <select class="textField" onChange={ApplySelectedDocId} id='dlDocuments'>
                            <option value='0'>Select Document</option>
                            {
                                getdocuments.map(doc => (
                                    <option value={doc._id}>{doc.friendlyName}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div class="col-md-6">
                        {(getActionMode == 'Save')?  
                        <>
                        <button type="button" class="secondaryButton mt-4" onClick={CancelActionMode} aria-label="cancel">Cancel</button>
                        <button type="button" class="primaryButton mt-4 ms-1" onClick={postconfigurations} aria-label="submit">Submit</button> </>
                        : ''}
                    </div>
                </div>
                <div class='row'>
                    <div className='col'>
                        <div key={Math.random()}>

                            {
                                getdocuments.filter(doc => doc._id == getSelectedDocId)?.map(ds =>
                                (
                                    <>
                                        <div class='row'>
                                            <div class="col mt-3">
                                                <label class='docTypeHeader'>Doc Type:&nbsp;</label>
                                                <label class='docTypeHeader'>{ds.documentData.docType}</label>

                                            </div>
                                        </div>

                                        {

                                            ds.documentData.namespaces?.map(nm => (

                                                <div class='row'>
                                                    <div class="col mt-3">
                                                        <div class='row'>
                                                            <div class='col header2'>
                                                                <label>Namespace:&nbsp;</label>
                                                                <label>{nm.name}</label>
                                                            </div>
                                                        </div>
                                                        <div class='row'>
                                                            {nm.labels?.map(lb =>

                                                            (
                                                                <div class='col-4'>

                                                                    <div class="card">
                                                                        <div class="card-body">
                                                                            <div class='row'>
                                                                                <div class='col-md-10'>
                                                                                    <label class='form-text'>{lb.name}</label>
                                                                                </div>



                                                                            </div>

                                                                            <input type="text" id={getSelectedDocId + '_' + nm.name + '_' + lb.name}
                                                                                defaultValue={lb.local_language_name} maxLength={50}
                                                                                placeholder='Label Local Language Name'
                                                                                class="textField formText" aria-label={lb.name} />

                                                                        </div>
                                                                    </div>



                                                                </div>
                                                            )
                                                            )}
                                                        </div>
                                                    </div>

                                                </div>

                                            ))

                                        }

                                    </>

                                ))

                            }

                        </div>
                    </div>

                </div>
                        {(getActionMode == 'Save')?  
                        <div class='row'>
                        <div class="col">
                        <button type="button" class="secondaryButton mt-4" onClick={CancelActionMode} aria-label="cancel">Cancel</button>
                                <button type="button" class="primaryButton mt-4 ms-1" onClick={postconfigurations} aria-label="submit">Submit</button>
                            </div>
                        </div> : ''}
                    </div>
        </Layout>
    );


    function ApplySelectedDocId() {
        setActionMode('Save');
        setSelectedDocId(document.getElementById('dlDocuments').value);
    }

    function CancelActionMode() {
        setActionMode('')
        document.getElementById('dlDocuments').value = '0';
        setSelectedDocId('0');
    }

    async function postconfigurations() {

        try {
            if (getSelectedDocId == '0') {
                toast.error('Invalid Document Name');
                return;
            }

            var configuredDocument = getdocuments.filter(doc => doc._id == getSelectedDocId)

            configuredDocument?.map(ds => {

                ds.documentData.namespaces?.map(nm => {

                    nm.labels?.map(lb => {
                        let labelLanguageName = document.getElementById(getSelectedDocId + '_' + nm.name + '_' + lb.name).value;
                        lb.local_language_name = labelLanguageName;
                    });

                });

            });



            let postData = {
                documentData: configuredDocument,
                _id: getSelectedDocId,
                friendlyName: configuredDocument.friendlyName
            }

            const response = await axios.request({
                method: 'POST',
                url: config.operatorportal.apibaseurl +'document/configurations/schemas',
                headers: { "content-type": "application/cbor", Authorization: `Bearer ${sessionStorage.getItem('access_token')}` },
                responseType: 'arraybuffer',
                responseEncoding: 'binary',
                data: cbor.encode(postData)
            });


            if (response.status == 200) {
                document.getElementById('dlDocuments').value = '0';
                setSelectedDocId('0');
                toast.success('Post request Succeded.');
            } else {
                toast.error('Failed.');
            }
            setActionMode('');
            document.getElementById('loadingProgressG').style.display = 'none';

        } catch (error) {
            document.getElementById('loadingProgressG').style.display = 'none';
            toast.error(error.message);
        }


    }

}


